import 'css-chunksrc/client/scenes/taskPopup/styles.scss';export default {
  "taskPopup": "_taskPopup_x8wfk_1",
  "header": "_header_x8wfk_13",
  "dateTimeInfo": "_dateTimeInfo_x8wfk_20",
  "timeRange": "_timeRange_x8wfk_27",
  "date": "_date_x8wfk_20",
  "actions": "_actions_x8wfk_38",
  "actionButton": "_actionButton_x8wfk_44",
  "trashIcon": "_trashIcon_x8wfk_62",
  "editIcon": "_editIcon_x8wfk_68",
  "title": "_title_x8wfk_74",
  "name": "_name_x8wfk_83",
  "description": "_description_x8wfk_92",
  "projectInfo": "_projectInfo_x8wfk_101",
  "label": "_label_x8wfk_109",
  "projectBadge": "_projectBadge_x8wfk_116",
  "icon": "_icon_x8wfk_124",
  "link": "_link_x8wfk_132",
  "projectName": "_projectName_x8wfk_140",
  "customFields": "_customFields_x8wfk_153"
};